"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var PropTypes = __importStar(require("prop-types"));
var helpers_1 = require("../../utils/helpers");
var propTypes = {
    progress: PropTypes.number,
    size: PropTypes.string,
    color: PropTypes.string,
    className: PropTypes.string,
    mods: PropTypes.string,
    style: PropTypes.object,
    testId: PropTypes.string,
    otherProps: PropTypes.object,
};
var RadialProgress = function (_a) {
    var progress = _a.progress, size = _a.size, color = _a.color, className = _a.className, mods = _a.mods, style = _a.style, testId = _a.testId, otherProps = _a.otherProps;
    var degrees = 360 * (progress / 100);
    var circle = {};
    if (degrees <= 180) {
        circle.first = degrees + "deg";
        circle.second = '0deg';
        circle.className = 'RadialProgress-circle';
    }
    else {
        circle.first = '180deg';
        circle.second = degrees + "deg";
        circle.className = 'RadialProgress-circle whole';
    }
    var radialClassName = (0, helpers_1.getClassName)(className, size && "RadialProgress--" + size, color && "RadialProgress--" + color, mods);
    return (React.createElement("div", __assign({ className: radialClassName, style: style, "data-testid": testId }, otherProps),
        React.createElement("div", { className: circle.className },
            React.createElement("div", { className: "RadialProgress-status", style: { transform: "rotate(" + circle.first + ")" } }),
            React.createElement("div", { className: "RadialProgress-status", style: { transform: "rotate(" + circle.second + ")" } }))));
};
RadialProgress.defaultProps = {
    progress: 0,
    size: null,
    color: null,
    className: 'RadialProgress',
    mods: null,
    style: {},
    testId: null,
    otherProps: {},
};
exports.default = RadialProgress;
